<!-- ========================= -->
<!-- SECTION HEADERS LOOP -->
<!-- ========================= -->

@for (header of sectionHeader; track $index) {

<ion-row class="ion-margin-top">

  <!-- ========================= -->
  <!-- SECTION TITLE -->
  <!-- ========================= -->
  <ion-col size="12" class="ion-no-padding">
    <ion-text class="header_desc">
      {{ header.iteM_DESCRIPTION }}
    </ion-text>
  </ion-col>

  <!-- ========================= -->
  <!-- SECTION ITEMS LOOP -->
  <!-- ========================= -->
  @for (item of getsectionItems(header); track $index) {

  <ion-col size-xs="12" size-md="6" class="ion-no-padding ion-padding-top ion-padding-bottom">
    <ion-row>

      <!-- ========================= -->
      <!-- ITEM MAIN CONTAINER -->
      <!-- ========================= -->
      <ion-col size="12" class="d-flex ion-no-padding">

        <!-- Item Icon -->
        <img [src]="'assets/InspectionImage/' + item.iteM_ICON_IMAGE_NAME" class="ion-icon borderBoxicon fixedWidth"
          alt="" />

        <!-- ========================= -->
        <!-- ITEM CONTENT -->
        <!-- ========================= -->
        <ion-row [ngClass]="{ 'ion-padding-start': !isMobileApp }">

          <!-- Item Description -->
          <ion-col size="12" [ngClass]="{ 'd-flex align-items-center ion-no-padding ion-padding-start': isMobileApp }">
            <ion-label>{{ item.iteM_DESCRIPTION }}</ion-label>
          </ion-col>

          <!-- ========================= -->
          <!-- INPUT TYPES -->
          <!-- ========================= -->

          @if(!isMobileApp){
          <ion-col size="12">
            <ng-container *ngTemplateOutlet="inspectionInput; context: { $implicit: item }"></ng-container>
          </ion-col>
          }

        </ion-row>

      </ion-col>

      @if(isMobileApp){
      <ion-row class="w-100">
        <ion-col size="12" class="ion-no-padding ion-padding-top">
          <ng-container *ngTemplateOutlet="inspectionInput; context: { $implicit: item }"></ng-container>
        </ion-col>
      </ion-row>
      }

      <!-- ========================= -->
      <!-- SAFETY DEFECT TOGGLE -->
      <!-- ========================= -->
      @if (item.isDefet != null && item.isDefet) {
      <div class="d-flex" [ngClass]="{
          'mt-4 align-items-center': !isEditInspection(),
          'mt-2 flex-column': isEditInspection()
        }">

        @if(isEditInspection())
        {
        <div class="mt-4 d-flex align-items-center">
          <ion-text>
            {{ 'PRE_USE_LABEL14' | translate }}&nbsp;:
          </ion-text>

          <ion-text class="ms-2">
            {{item.shorT_DEFECT_ID}}
          </ion-text>
        </div>
        }

        <div class="d-flex align-items-center gap-2" [ngClass]="{'mt-2':isEditInspection()}">
          <ion-text>
            {{ 'SAFETY_DEFECTS_DIALOG_BOX' | translate }}
          </ion-text>

          <ion-toggle color="danger" labelPlacement="start" [checked]="item.safetY_IMPACT_IND_BOOL == true"
            [(ngModel)]="item.safetY_IMPACT_IND_BOOL" [disabled]="isEditInspection()!"
            (ionChange)="onChangeSafetyToggle(item)">
          </ion-toggle>
        </div>
      </div>
      }

      <!-- ========================= -->
      <!-- DEFECT COMMENT & MEDIA -->
      <!-- ========================= -->
      @if (item.inpuT_TYPE === 'TICKBOX' && item.isDefet != null && item.isDefet) {

      <!-- Comment -->
      <ion-col size="12" [ngClass]="{ 'ion-no-padding': isMobileApp }">
        <ion-item class="ion-no-padding" [ngClass]="{
                  'invalid': item.commentError && !isEditInspection(),
                  'w-75': !isMobileApp,
                  'w-100 mt-3': isMobileApp
                }">
          <ion-textarea maxlength="500" placeholder="Add Comment" [(ngModel)]="item.comment"
            [readonly]="isEditInspection()" (ionInput)="validateComment(item, $event)">
          </ion-textarea>
        </ion-item>
      </ion-col>

      <!-- Comment Error -->
      @if (item.commentError && !isEditInspection()) {
      <ion-note class="text-danger-accent">
        {{ item.commentError }}
      </ion-note>
      }

      <!-- Media Actions -->
      <div class="d-flex align-items-center" [ngClass]="{
                'w-75': !isMobileApp,
                'w-100': isMobileApp
              }">
        <div class="d-flex">

          <!-- Upload -->
          @if (!isEditInspection() && !isMobileApp) {
          <label class="cursor-pointer" [ngClass]="{ 'text-danger-accent': item.photO_MANDATORY_ANS }"
            for="{{ 'file_input' + item.veH_INSPECT_ITEM_ID }}">
            <ion-icon src="assets/imgs/camera-sharp.svg" size="large" class="uplaod-img-btn"></ion-icon>
          </label>
          }

          @if (!isEditInspection() && isMobileApp) {
          <ion-icon (click)="presentImgActionSheet($event, item.veH_INSPECT_ITEM_ID)"
            (keydown.enter)="presentImgActionSheet($event, item.veH_INSPECT_ITEM_ID)" src="assets/imgs/camera-sharp.svg"
            size="large" class="uplaod-img-btn"></ion-icon>
          }

          <!-- Preview -->
          @if (item.defect_Imedia !== null) {
          <ion-icon src="assets/imgs/eye.svg" size="large" class="ms-2 cursor-pointer" (click)="showModal(item)"
            (keydown.enter)="showModal(item)"></ion-icon>
          }

          <!-- Delete -->
          @if (item.defect_Imedia != null && !isEditInspection()) {
          <ion-icon src="assets/imgs/trash.svg" size="large" class="ms-2 cursor-pointer" (click)="removeFile(item)"
            (keydown.enter)="removeFile(item)"></ion-icon>
          }

        </div>

        <!-- Hidden File Input -->
        @if (!isMobileApp) {
        <input type="file" class="hidden-file-input" id="{{ 'file_input' + item.veH_INSPECT_ITEM_ID }}"
          name="imageToupload" accept=".jpg,.jpeg,.png"
          (change)="fileUpload($event, item.veH_INSPECT_ITEM_ID)" />
        }

        <!-- Character Counter -->
        <ion-text class="primary-color pe-2 d-block ms-auto">
          {{ item?.comment?.length ?? 0 }}/500
        </ion-text>

      </div>
      
      <!-- Mandatory Photo Validation -->
      @if (item.photO_MANDATORY_ANS && !isEditInspection()) {
      <ion-note class="text-danger-accent">
        {{ 'PHOTO_VALIDATION_INLINE1' | translate }}
      </ion-note>
      }

      @if (!isMobileApp && !isEditInspection() && (!item?.isFileTypeValid || !item?.isFileSizeValid) && item?.invalidFileMessage && item?.invalidFileMessage != '') {
        <ion-note class="text-danger-accent"> {{ item.invalidFileMessage }} </ion-note>
      }
    }

    </ion-row>
  </ion-col>

  <!-- Divider for Mobile -->
  @if (isMobileApp) {
  <hr class="w-100" />
  }

  }
</ion-row>
}

<ion-row>

  <!-- ========================= -->
  <!-- ROADWORTHY DECLARATION -->
  <!-- ========================= -->
  @if (inspectionItems().length > 0) {

  <ion-col size="12" class="d-flex flex-column ion-margin-top">
    <ion-text class="primary-color roadworthy_desc">
      {{ 'ROADWORTHY_DECLARATION' | translate }}
    </ion-text>

    @if (isRoadworthyValidation) {
    <ion-note class="text-danger-accent">
      {{ 'ROADWORTHY_MSG' | translate }}
    </ion-note>
    }

    <ion-text class="mt-2">
      {{ 'ROADWORTHY_DECLARATION_DETAIL' | translate }}
    </ion-text>
  </ion-col>

  <!-- Roadworthy Buttons -->
  <ion-col size="4">
    <ion-buttons>
      <ion-button class="pui_btn shadow-none" [disabled]="isDefectSafetyRelated || isEditInspection()"
        [ngClass]="{ 'selected': isRoadWorthy == true }" (click)="changeIsRoadworthy(true)"
        (keydown.enter)="changeIsRoadworthy(true)">
        <ion-text class="ion-padding-start ion-padding-end">
          {{ 'SAFETY_DEFECTS_DIALOG_BOX_SAFE_BTN' | translate }}
        </ion-text>
      </ion-button>

      <ion-button class="pui_btn shadow-none" [disabled]="isDefectSafetyRelated || isEditInspection()"
        [ngClass]="{ 'selected': isRoadWorthy == false }" (click)="changeIsRoadworthy(false)"
        (keydown.enter)="changeIsRoadworthy(false)">
        <ion-text class="ion-padding-start ion-padding-end">
          {{ 'SAFETY_DEFECTS_DIALOG_BOX_NON_SAFE_BTN' | translate }}
        </ion-text>
      </ion-button>
    </ion-buttons>
  </ion-col>

  <!-- Safety Warning -->
  @if (isDefectSafetyRelated) {
  <ion-col size="12">
    <div class="safety-defect-warning d-flex align-items-center p-2">
      <ion-icon src="assets/imgs/holman/info-icon-blue.svg" [size]="isMobileApp ? 'large' : ''"></ion-icon>
      <ion-text class="ms-2">
        {{ 'MSG38' | translate }}
      </ion-text>
    </div>
  </ion-col>
  }

  <!-- ========================= -->
  <!-- TRAILER QUESTION -->
  <!-- ========================= -->
  @if((isEditInspection() && isTowingTrailer !== null && showTowingQn()) || (!isEditInspection() && isRoadWorthy &&
  showTowingQn()))
  {
  <ion-col size="12" class="d-flex flex-column ion-margin-top">
    <ion-text class="primary-color roadworthy_desc">
      {{ 'TOWING_TRAILER_QUETION' | translate }}
    </ion-text>

    @if (isTrailerValidation) {
    <ion-note class="text-danger-accent">
      {{ 'TOWING_TRAILER_ERROR' | translate }}
    </ion-note>
    }

    <ion-text class="mt-2">
      {{ 'TOWING_TRAILER_DISCRIPTION' | translate }}
    </ion-text>
  </ion-col>

  <!-- Trailer Buttons -->
  <ion-col size="4">
    <ion-buttons>
      <ion-button class="pui_btn shadow-none" [disabled]="isEditInspection()"
        [ngClass]="{ 'selected': isTowingTrailer == true }" (click)="changeIsTowingTrailer(true)"
        (keydown.enter)="isTowingTrailer = true">
        <ion-text class="ion-padding-start ion-padding-end">
          {{ 'SAFETY_DEFECTS_DIALOG_BOX_SAFE_BTN' | translate }}
        </ion-text>
      </ion-button>

      <ion-button class="pui_btn shadow-none" [disabled]="isEditInspection()"
        [ngClass]="{ 'selected': isTowingTrailer == false }" (click)="changeIsTowingTrailer(false)"
        (keydown.enter)="isTowingTrailer = false">
        <ion-text class="ion-padding-start ion-padding-end">
          {{ 'SAFETY_DEFECTS_DIALOG_BOX_NON_SAFE_BTN' | translate }}
        </ion-text>
      </ion-button>
    </ion-buttons>
  </ion-col>
  }
  }

  <!-- ========================= -->
  <!-- FOOTER ACTIONS -->
  <!-- ========================= -->

  <ion-toolbar class="bg-transparent" [ngClass]="{
        'mt-5': isMobileApp,
        'mt-3': !isMobileApp
      }">
    <ion-buttons slot="end">

      @if(!isEditInspection())
      {
      <ion-button class="btn_secondary_outline">
        <ion-text [routerLink]="getCancelRedirectUrl()" [ngClass]="{
              'p-2': !isMobileApp,
              'p-1': isMobileApp
            }">
          {{ 'USER_LABEL14' | translate }}
        </ion-text>
      </ion-button>

      @if(inspectionItems().length>0){
      <ion-button class="btn_secondary" (click)="submitInspection()" (keydown.enter)="submitInspection()">
        <ion-text class="text-white" [ngClass]="{
              'p-2': !isMobileApp,
              'p-1': isMobileApp
            }">
          {{ 'Submit_btn' | translate }}
        </ion-text>
      </ion-button>
      }

      }

      @if(isEditInspection())
      {
      <ion-button class="pui_btn" routerLink="/pre-use-inspection">
        <ion-text [ngClass]="{
              'p-2': !isMobileApp,
              'p-1': isMobileApp
            }">
          {{ 'EMAIL_LABEL5' | translate }}
        </ion-text>
      </ion-button>
      }

    </ion-buttons>
  </ion-toolbar>
</ion-row>

<ng-template #inspectionInput let-item>

  <!-- ========================= -->
  <!-- TICKBOX INPUT -->
  <!-- ========================= -->
  @if (item.inpuT_TYPE === 'TICKBOX') {
  <ion-row>
    <!-- OK Button -->
    <ion-button id="{{ 'ok' + item.veH_INSPECT_ITEM_ID }}" class="pui_btn inspectionWidth shadow-none"
      [ngClass]="{ 'selected': item.isDefet == false && item.iS_NA == false, 'ms-0': isMobileApp }"
      [disabled]="isEditInspection()" (click)="toggleSelect(item)" (keydown.enter)="toggleSelect(item)">
      {{ buttonCaptions()?.tickboX_Y_CAPTION ?? '---' }}
    </ion-button>

    <!-- Fail Button -->
    <ion-button id="{{ 'nok' + item.veH_INSPECT_ITEM_ID }}" class="pui_btn inspectionWidth shadow-none"
      [ngClass]="{ 'selected': item.isDefet == true && item.iS_NA == false, 'ms-1': isMobileApp }"
      [disabled]="isEditInspection()" (click)="toggleFail(item)" (keydown.enter)="toggleFail(item)">
      {{ buttonCaptions()?.tickboX_N_CAPTION ?? '---' }}
    </ion-button>

    <!-- NA Button -->
    @if (item.alloW_NA) {
    <ion-button id="{{ 'na' + item.veH_INSPECT_ITEM_ID }}" class="pui_btn inspectionWidth shadow-none"
      [ngClass]="{ 'selected': item.iS_NA == true && item.isDefet == false, 'ms-1': isMobileApp }"
      [disabled]="isEditInspection()" (click)="toggleNa(item)" (keydown.enter)="toggleNa(item)">
      {{ buttonCaptions()?.tickboX_NA_CAPTION ?? '---' }}
    </ion-button>
    }
  </ion-row>
  }

  <!-- ========================= -->
  <!-- TEXT / NUMBER / POSTCODE INPUT -->
  <!-- ========================= -->
  @if (item.inpuT_TYPE === 'TEXT' || item.inpuT_TYPE === 'NUMBER' || item.inpuT_TYPE === 'POSTCODE') {
  <ion-item class="ion-no-padding" [ngClass]="{ 'invalid': item.commentError }">
    <ion-input (ionInput)="itemValueChange(item)" placeholder="Enter value" name="item_Value" required
      [(ngModel)]="item.item_Value" [type]="getInpType(item.inpuT_TYPE)" [readonly]="isEditInspection()"
      #itemValueCtrl="ngModel">
    </ion-input>
  </ion-item>

  <!-- Validation Message -->
  @if(item.commentError) {
  <ion-note class="text-danger-accent">
    {{item.commentError}}
  </ion-note>
  }
  }

</ng-template>